(() => {
  const one = (selector) => document.querySelector(selector);
  const all = (selector) => [...document.querySelectorAll(selector)];
  const root = () => window.Shopify?.routes?.root || '/';
  const drawer = one('[data-cart-drawer]');
  const scrim = one('[data-scrim]');

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'GBP'
  }).format((Number(cents) || 0) / 100);

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ct-cart-open');
    if (scrim) scrim.hidden = true;
  };

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ct-cart-open');
    if (scrim) scrim.hidden = false;
    drawer.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
  };

  const updateDeliveryProgress = (cart) => {
    const progressEl = one('[data-delivery-progress]');
    if (!progressEl) return;
    const textEl = progressEl.querySelector('[data-delivery-text]');
    const barEl = progressEl.querySelector('[data-delivery-bar]');
    if (textEl) textEl.textContent = progressEl.dataset.freeShippingText || 'Complimentary UK delivery on every order';
    if (barEl) barEl.style.width = '100%';
  };

  const renderCart = (cart) => {
    if (!cart) return;
    all('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count || 0; });
    updateDeliveryProgress(cart);

    const upsell = one('[data-cart-upsell]');
    if (upsell) upsell.style.display = 'none';

    const body = one('[data-cart-body]');
    const footer = one('[data-cart-footer]');
    if (!body) return;

    if (!Array.isArray(cart.items) || cart.items.length === 0) {
      body.innerHTML = `
        <div class="empty-cart">
          <span>CT</span>
          <h3>Your ritual starts here.</h3>
          <p>Your bag is currently empty.</p>
          <a href="${root()}collections/all">Explore the collection →</a>
        </div>
      `;
      if (footer) footer.hidden = true;
      return;
    }

    const handles = new Set(cart.items.map((item) => item.handle));
    const hasSerumDuo = handles.has('morning-dew-2') && handles.has('immortelle-renew-serum-nightly-bakuchiol-face-serum');
    const duoNotice = hasSerumDuo ? '<div class="ct-cart-ritual-note"><strong>Serum Ritual Duo</strong><span>Morning Dew + Immortelle Repair are together in your bag.</span></div>' : '';

    body.innerHTML = duoNotice + cart.items.map((item, index) => `
      <div class="cart-line">
        ${item.image ? `<img src="${item.image}" alt="${String(item.product_title || item.title || '').replace(/"/g, '&quot;')}">` : '<div class="cart-thumb">CT</div>'}
        <div>
          <h3>${item.product_title || item.title || ''}</h3>
          <p>${item.variant_title === 'Default Title' ? '' : (item.variant_title || '')}</p>
          <div class="cart-line-controls">
            <strong>${money(item.final_line_price)}</strong>
            <div class="quantity">
              <button type="button" data-change-qty data-line="${index + 1}" data-qty="${Math.max(0, item.quantity - 1)}">-</button>
              <b>${item.quantity}</b>
              <button type="button" data-change-qty data-line="${index + 1}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <button type="button" class="remove-line" data-remove-line="${index + 1}">Remove</button>
        </div>
      </div>
    `).join('');

    if (footer) footer.hidden = false;
    const totalEl = one('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  };

  const fetchCart = async () => {
    const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const refreshCart = async () => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      console.error('[CT cart]', error);
      return null;
    }
  };

  const addFormToCart = async (form) => {
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to add item to cart');
    await refreshCart();
    openDrawer();
  };


  const getFirstAvailableVariant = async (handle) => {
    const response = await fetch(`${root()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Unable to load ${handle}`);
    const product = await response.json();
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
    if (!variant?.id) throw new Error(`No purchasable variant for ${handle}`);
    return variant.id;
  };

  const addSetToCart = async (setKey, button) => {
    const setHandles = {
      'serum-ritual-duo': ['morning-dew-2', 'immortelle-renew-serum-nightly-bakuchiol-face-serum'],
      'therapy-set': ['nu-originel-the-pure-base', 'rose-ardente-lip-treatment', 'passion-doree-lip-treatment'],
      'lip-therapy-set': ['nu-originel-the-pure-base', 'rose-ardente-lip-treatment', 'passion-doree-lip-treatment'],
      'lip-therapy-trio': ['nu-originel-the-pure-base', 'rose-ardente-lip-treatment', 'passion-doree-lip-treatment'],
      'discovery-set': ['les-baumes-treatment-rose-ardente-enhance', 'les-baumes-treatment-nu-originel-repair', 'les-baumes-treatment-passion-doree-radiance']
    };
    const handles = setHandles[setKey];
    if (!handles) return false;
    if (button) button.disabled = true;
    try {
      const ids = await Promise.all(handles.map(getFirstAvailableVariant));
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
      });
      if (!response.ok) throw new Error('Unable to add complete set');
      await refreshCart();
      openDrawer();
      return true;
    } finally {
      if (button) button.disabled = false;
    }
  };

  const currentProductHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const addCurrentProductToCart = async () => {
    const handle = currentProductHandle();
    if (!handle) throw new Error('No Shopify product found for this page');

    const productResponse = await fetch(`${root()}products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!productResponse.ok) throw new Error('Unable to load product');
    const product = await productResponse.json();
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
    if (!variant?.id) throw new Error('No purchasable variant found');

    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add item to cart');
    await refreshCart();
    openDrawer();
  };

  refreshCart();
  document.addEventListener('DOMContentLoaded', refreshCart);
  window.addEventListener('pageshow', refreshCart);

  all('[data-cart-open], [data-cart-trigger="true"]').forEach((button) => {
    if (button.closest('.mobile-buy-bar, .set-mobile-buy')) return;
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      await refreshCart();
      openDrawer();
    });
  });

  all('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  scrim?.addEventListener('click', closeDrawer);

  document.addEventListener('click', async (event) => {
    const qtyBtn = event.target.closest('[data-change-qty]');
    const removeBtn = event.target.closest('[data-remove-line]');
    const typeButtonAdd = event.target.closest('.set-add[type="button"], .mobile-buy-bar button, .set-mobile-buy button');
    const upsellBtn = event.target.closest('[data-add-upsell]');

    try {
      if (qtyBtn) {
        const line = Number(qtyBtn.dataset.line);
        const quantity = Number(qtyBtn.dataset.qty);
        const response = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!response.ok) throw new Error('Unable to update quantity');
        renderCart(await response.json());
        return;
      }

      if (removeBtn) {
        const line = Number(removeBtn.dataset.removeLine);
        const response = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        if (!response.ok) throw new Error('Unable to remove item');
        renderCart(await response.json());
        return;
      }

      if (upsellBtn) {
        event.preventDefault();
        const variantId = Number(upsellBtn.dataset.variantId);
        if (!variantId) return;
        upsellBtn.disabled = true;
        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        upsellBtn.disabled = false;
        if (!response.ok) throw new Error('Unable to add recommended product');
        await refreshCart();
        openDrawer();
        return;
      }

      if (typeButtonAdd) {
        event.preventDefault();
        const setKey = typeButtonAdd.dataset.addCart;
        if (setKey && await addSetToCart(setKey, typeButtonAdd)) return;
        const form = typeButtonAdd.closest('form') || (typeButtonAdd.closest('.mobile-buy-bar') ? one('.product-buy-form') : null);
        if (form) await addFormToCart(form);
        else await addCurrentProductToCart();
      }
    } catch (error) {
      console.error('[CT cart]', error);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"], form[data-product-form], .product-buy-form, .set-product-form, .byo-product-form')) return;

    event.preventDefault();
    try {
      const submitter = event.submitter;
      const setKey = submitter?.dataset?.addCart;
      if (setKey && await addSetToCart(setKey, submitter)) return;
      await addFormToCart(form);
    } catch (error) {
      console.error('[CT cart]', error);
    }
  });

  const bindOverlay = (openSelector, closeSelector, overlaySelector) => {
    const overlay = one(overlaySelector);
    all(openSelector).forEach((btn) => btn.addEventListener('click', () => { if (overlay) overlay.hidden = false; }));
    all(closeSelector).forEach((btn) => btn.addEventListener('click', () => { if (overlay) overlay.hidden = true; }));
  };
  bindOverlay('[data-search-open]', '[data-search-close]', '[data-search-overlay]');

  document.addEventListener('cart:refresh', (event) => {
    const cart = event.detail?.cart || event.detail;
    if (cart?.items) renderCart(cart);
    else refreshCart();
  });
  document.addEventListener('cart:open', async () => {
    await refreshCart();
    openDrawer();
  });
  all('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => {
    requestAnimationFrame(() => one('[data-search-overlay] input[type="search"]')?.focus());
  }));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      const search = one('[data-search-overlay]');
      if (search) search.hidden = true;
    }
  });

  function initByoEngine() {
    const palette = one('[data-byo-palette]');
    const slots = all('[data-slot]');
    const countLabel = one('[data-byo-count]');
    const textLabel = one('[data-byo-text]');
    const submitBtn = one('[data-byo-submit]');
    const mobileBtn = one('[data-byo-mobile-submit]');
    const btnText = one('[data-byo-btn-text]');
    if (!palette && !slots.length) return;

    let selected = [];

    const update = () => {
      slots.forEach((slot, index) => {
        const item = selected[index];
        if (item) {
          slot.className = `build-slot filled ${item.className}`;
          slot.innerHTML = `<div class="treatment-tube ${item.className}"><span class="tube-cap"></span><span class="tube-mark">CT</span><span class="tube-title">${item.title}</span></div><span class="slot-remove-badge" title="Remove ${item.shade}">✕</span>`;
        } else {
          slot.className = 'build-slot empty';
          slot.innerHTML = '<span class="slot-text">CHOOSE<br>A BALM</span>';
        }
      });

      palette?.querySelectorAll('.byo-swatch').forEach((swatch) => {
        swatch.classList.toggle('active', selected.some((s) => s.shade === swatch.dataset.shade));
      });

      const count = selected.length;
      if (countLabel) countLabel.textContent = `Choose 3 of 5 (${count} selected)`;
      if (textLabel) textLabel.textContent = count ? `${count} of 3 selected (${selected.map((s) => s.shade).join(', ')})` : 'Personalised selection (0 of 3)';
      if (submitBtn) {
        submitBtn.disabled = count !== 3;
        submitBtn.dataset.meta = selected.map((s) => s.shade).join(', ');
      }
      if (btnText) btnText.textContent = count === 3 ? 'Add Custom Trio to Bag' : `Select ${3 - count} more balm${3 - count === 1 ? '' : 's'} to continue`;
      if (mobileBtn) {
        mobileBtn.disabled = count !== 3;
        mobileBtn.textContent = count === 3 ? 'Add Custom Trio' : `Select ${3 - count} more`;
        mobileBtn.dataset.meta = selected.map((s) => s.shade).join(', ');
      }
    };

    palette?.addEventListener('click', (event) => {
      const swatch = event.target.closest('.byo-swatch');
      if (!swatch) return;
      const shade = swatch.dataset.shade;
      const className = swatch.dataset.class;
      const title = shade.toUpperCase().replace(' ', '<br>');
      const existing = selected.findIndex((s) => s.shade === shade);
      if (existing > -1) selected.splice(existing, 1);
      else if (selected.length < 3) selected.push({ shade, className, title });
      else selected[2] = { shade, className, title };
      update();
    });

    one('[data-build-slots]')?.addEventListener('click', (event) => {
      const slot = event.target.closest('[data-slot]');
      if (!slot) return;
      const index = Number(slot.dataset.slot);
      if (selected[index]) selected.splice(index, 1);
      update();
    });

    update();
  }

  function initDuoEngine() {
    const palette = one('[data-duo-palette]');
    const slots = all('[data-duo-slot]');
    const textLabel = one('[data-duo-text]');
    const submitBtn = one('[data-duo-submit], .gift-duo-page .set-add');
    if (!palette && !slots.length) return;

    let selected = [
      { shade: 'Rouge Défendu', className: 'rouge' },
      { shade: 'Passion Dorée', className: 'passion' }
    ];

    const update = () => {
      slots.forEach((slot, index) => {
        const item = selected[index];
        if (!item) return;
        slot.className = `duo-slot filled ${item.className}`;
        slot.innerHTML = `<i class="mini-paper-tube ${item.className}">Les<br>Baumes</i>`;
      });
      palette?.querySelectorAll('.byo-swatch').forEach((swatch) => {
        swatch.classList.toggle('active', selected.some((s) => s.shade === swatch.dataset.shade));
      });
      if (textLabel) textLabel.textContent = `Your personalised gift pair (${selected.map((s) => s.shade).join(', ')})`;
      if (submitBtn) submitBtn.dataset.meta = selected.map((s) => s.shade).join(', ');
    };

    palette?.addEventListener('click', (event) => {
      const swatch = event.target.closest('.byo-swatch');
      if (!swatch) return;
      const next = { shade: swatch.dataset.shade, className: swatch.dataset.class };
      const existing = selected.findIndex((s) => s.shade === next.shade);
      if (existing > -1 && selected.length > 1) selected.splice(existing, 1);
      else if (existing === -1 && selected.length < 2) selected.push(next);
      else if (existing === -1) selected[1] = next;
      update();
    });

    update();
  }

  initByoEngine();
  initDuoEngine();

  const selectedSwatches = [];
  const swatchContainer = one('[data-swatch-picker]');
  const selectionText = one('[data-selection-text]');
  if (swatchContainer && selectionText) {
    swatchContainer.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-shade]');
      if (!swatch) return;
      const shade = swatch.dataset.shade;
      const index = selectedSwatches.indexOf(shade);
      if (index > -1) selectedSwatches.splice(index, 1);
      else if (selectedSwatches.length < 3) selectedSwatches.push(shade);
      selectionText.textContent = selectedSwatches.length ? `${selectedSwatches.length} of 3 selected (${selectedSwatches.join(', ')})` : 'Personalised selection';
    });
  }

  const filterChips = all('[data-filter-chip]');
  const cards = all('.collection-card');
  filterChips.forEach((chip) => chip.addEventListener('click', () => {
    filterChips.forEach((c) => {
      c.classList.remove('active');
      c.setAttribute('aria-pressed', 'false');
    });
    chip.classList.add('active');
    chip.setAttribute('aria-pressed', 'true');
    const category = chip.dataset.filterChip;
    cards.forEach((card) => { card.style.display = category === 'all' || card.dataset.category === category ? 'flex' : 'none'; });
  }));
})();
